"use strict";
window.addEventListener('load', function () {
    var burger = document.querySelector('.navbar-burger');
    var menu = document.querySelector('.navbar-menu');
    var close = document.querySelector('.navbar-close');
    burger.addEventListener('click', function () {
        if (menu.classList.contains('hidden')) {
            menu.classList.remove('hidden');
        }
    });
    close.addEventListener('click', function () {
        menu.classList.add('hidden');
    });
});
